export default "__VITE_ASSET__01a8bbcf__"